//
import { RTableHeaders } from '@/components/reusable_components/next'

//
export default RTableHeaders
  .from([
    {
      text: 'n°',
      value: 'account_number',
    },
    {
      text: 'proveedor',
      value: 'pch_provider_alias_name',
    },
    {
      text: 'tipo',
      value: 'g_type_account_bank_type',
    },
    {
      text: 'banco',
      value: 'g_bank_bank',
    },
    {
      text: 'contacto',
      value: 'email',
    },
  ])